module.exports = __webpack_public_path__ + "img/category-jinji.bfe1ba12.svg";